import { ADMIN_GET_NDA_AGREEMENT, ADMIN_GET_NDA_AGREEMENT_FAILED, ADMIN_GET_NDA_AGREEMENT_SUCCESS } from "./constants";

export const adminGetNdaAgreement = () =>({
    type: ADMIN_GET_NDA_AGREEMENT
})

export const adminGetNdaAgreementSuccess = payload =>({
    type: ADMIN_GET_NDA_AGREEMENT_SUCCESS,
    payload
})

export const adminGetNdaAgreementFailed = payload =>({
    type: ADMIN_GET_NDA_AGREEMENT_FAILED,
    payload
})